exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-3c28544f] .el-table__expanded-cell {\n  padding: 0px 0px;\n}\n[data-v-3c28544f] .el-table th {\n  padding: 6px 0;\n}\n.button-bottom[data-v-3c28544f] {\n  border-radius: 0;\n  margin-left: 3px;\n}\n", ""]);

// exports
